import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import NewPasswordSetup from './NewPasswordSetup';

loadDOMComponent({
	selector: 'react-new-password-setup',
	callback: ({ container, context }: any) => {
		const token = container.getAttribute('token');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<NewPasswordSetup token={token} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
